import { Form, Spin } from 'antd';
import Box from 'components/Box';
import Empty from 'components/Empty';
import { get } from 'lodash';
import moment, { Moment } from 'moment';
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IScheduleBookingDateItem } from 'services/shop/types/booking';
import styled from 'styled-components';
import { getTimeLinesByDdd } from 'utils/getTimeLines';
import { getTimeSections } from '../QuickBookingV2/helpers';

type Ref = {
  setLoading: (value: boolean) => void;
};
type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  detailApt?: boolean;
};
export const useStartTimesRef = () => useRef<Ref>(null);
const StartTimes = forwardRef<Ref, Props>(({ value, onChange = () => undefined, detailApt }, ref) => {
  const form = Form.useFormInstance();
  const dateValue: Moment | null = Form.useWatch('date', form);
  const [loading, setLoading] = useState(false);
  const schedule = shopSelectors.data.scheduleBooking();

  const timelines = useMemo(() => {
    const scheduleData = get(schedule, dateValue?.format('ddd') || '', null) || { enable: true, endTime: '21:00', startTime: '08:00' } as IScheduleBookingDateItem;
    return getTimeLinesByDdd(moment(scheduleData.startTime, 'HH:mm'), moment(scheduleData.endTime, 'HH:mm'), 15).map(o => o.id);
  }, [dateValue, schedule]);

  useImperativeHandle(ref, () => ({
    setLoading,
  }));

  return (
    <Spin spinning={loading} >
      <Form.Item name={'time-slots'} noStyle>
        <TimeSlots detailApt={detailApt} loading={loading} dateValue={value} onChangeDate={onChange} baseTimesline={timelines} />
      </Form.Item>
    </Spin>
  );
});
StartTimes.displayName = 'StartTimes';
export default StartTimes;
const TimeSlots = ({ value: timeLines = [], dateValue, onChangeDate, baseTimesline = [] }: { baseTimesline?: string[], value?: string[], dateValue?: string, onChangeDate: (value: string) => void; loading?: boolean, detailApt?: boolean }) => {
  const sections = useMemo(() => getTimeSections(baseTimesline), [baseTimesline]);

  return (
    <ContainerBox>
      {sections.morning.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Morning</div>
        <StartTimeChange value={dateValue} timeslots={sections.morning} onChange={onChangeDate} activeTimeslots={timeLines} />
      </div>}
      {sections.afternoon.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Afternoon</div>
        <StartTimeChange value={dateValue} timeslots={sections.afternoon} onChange={onChangeDate} activeTimeslots={timeLines} />
      </div>}
      {sections.evening.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Evening</div>
        <StartTimeChange value={dateValue} timeslots={sections.evening} onChange={onChangeDate} activeTimeslots={timeLines} />
      </div>}
    </ContainerBox>
  );
};
const StartTimeChange = ({ value, onChange, timeslots = [], activeTimeslots = [] }: { value?: string, onChange?: (value: string) => void; timeslots?: string[], activeTimeslots?: string[] }) => {
  return (
    <Container>
      {timeslots.map((o: string) => {
        const disabled = !activeTimeslots.includes(o);
        return (
          <button disabled={disabled} type='button' onClick={() => !disabled && onChange?.(o)} key={o} className={`start-time-item ${value === o ? 'active' : ''}`}>
            <span>{o}</span>
          </button>
        );
      })}
    </Container>
  );
};

const ContainerBox = styled(Box)`

.time-slot-section {
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: #F6F7FC;
}

.section-sublabel {
  color: #505050;
  text-align: left;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  align-self: stretch;
  gap: 8px;
  zoom: 0.85;
  .start-time-item {
    display: flex;
    padding: 16px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid #CCD4DC;
      background: #FFF;
    span {
      color: #505050;
      text-align: center;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.active {
      border: 1px solid #2D6772;
      background: #2D6772;
      span {
        color: #FFF;
      }
    }
    &:disabled {
      opacity: 0.5;
      position: relative;
      &:before {
        height: 3px;
        position: absolute;
        top: 50%;
        width: 90%;
        background: #e11d48;
        content: " ";
        transform: translateY(-50%);
      }
    }
  }
`;